export const imageCarouselContentStyles = {
  alpha: {
    slots: {
      borderRadius: 'rounded',
    },
  },
  bravo: {
    slots: {
      borderRadius: 'rounded',
    },
  },
  charlie: {
    slots: {
      borderRadius: 'rounded',
    },
  },
  charlie2: {
    slots: {
      borderRadius: '',
    },
  },
}
